"use strict";
//  Copyright 2018, Venkat Peri.
//
//  Permission is hereby granted, free of charge, to any person obtaining a
//  copy of this software and associated documentation files (the
//  "Software"), to deal in the Software without restriction, including
//  without limitation the rights to use, copy, modify, merge, publish,
//  distribute, sublicense, and/or sell copies of the Software, and to permit
//  persons to whom the Software is furnished to do so, subject to the
//  following conditions:
//
//  The above copyright notice and this permission notice shall be included
//  in all copies or substantial portions of the Software.
//
//  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
//  OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
//  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
//  NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
//  DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
//  OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
//  USE OR OTHER DEALINGS IN THE SOFTWARE.
Object.defineProperty(exports, "__esModule", { value: true });
var arrayEqual_1 = require("./util/arrayEqual");
/**
 * @hidden
 * @param {State} s
 * @return {s is string}
 */
function isStringState(s) {
    return typeof s === "string";
}
exports.isStringState = isStringState;
/**
 * @hidden
 * @param s
 * @return {boolean}
 */
function isComplexState(s) {
    return typeof s !== "string";
}
exports.isComplexState = isComplexState;
/**
 * @hidden
 * @param s
 * @return {arg is Array<any>}
 */
function isArrayState(s) {
    return Array.isArray(s);
}
exports.isArrayState = isArrayState;
/**
 * @hidden
 * @param s
 * @return {boolean}
 */
function isObjState(s) {
    return typeof s === "object";
}
exports.isObjState = isObjState;
/**
 * @hidden
 * @param s
 * @return {string}
 */
function stateName(s) {
    if (!s) {
        return '';
    }
    if (typeof s === "string") {
        return s;
    }
    if (Array.isArray(s)) {
        return s[0];
    }
    return s.name;
}
exports.stateName = stateName;
/**
 * @hidden
 * @param a
 * @param b
 * @return {boolean}
 */
function stateEquals(a, b) {
    if (isStringState(a) && isStringState(b)) {
        return a === b;
    }
    if (isArrayState(a) && isArrayState(b)) {
        return arrayEqual_1.arrayEqual(a, b);
    }
    return isObjState(a) && isObjState(b) ? arrayEqual_1.objEqual(a, b) : false;
}
exports.stateEquals = stateEquals;
/**
 * @hidden
 * @param s
 * @return {string}
 */
function stateRoute(s) {
    if (!s) {
        return "*";
    }
    if (isStringState(s)) {
        return String(s);
    }
    if (isArrayState(s)) {
        return s.join("/");
    }
    return s.name + "/" +
        Object.entries(s)
            .filter(function (_a) {
            var k = _a[0];
            return k !== "name";
        })
            .map(function (x) { return x.join("/"); }).join("/");
}
exports.stateRoute = stateRoute;
//# sourceMappingURL=State.js.map